<template>
    <div id="projectPC">
        <div class="colspan1 clearfix" >
            <div class="left clearfix">
                <img v-if="projectData.cover_photo_text" v-lazy="projectData.cover_photo_text.url" alt="">
            </div>
            <div class="right clearfix">
                <span class="top clearfix">{{projectData.name}} <i></i> </span>
                <div class="main clearfix">
                    <p class="p1 clearfix">
                        已筹到<span>￥{{Number(projectData.donation_sum)>10000 ? (Number(projectData.donation_sum)/10000).toFixed(2)+'万':projectData.donation_sum }}</span>
                    </p>
                    <p class="p2 clearfix">
                        爱心人次 <span>{{projectData.donation_count}}</span>
                    </p>
                </div>
                <div class="footer">
                    <div v-if="projectData.raise_money"  >目标金额：<span>{{projectData.raise_money}}</span></div>
                    <div v-else  >目标金额：<span>无上限</span></div>
                    <div>爱心时间：<span>{{projectData.begin_time}} 至 {{projectData.end_time}}</span></div>
                    <div v-if="projectData.if_donation==1"  class="button clearfix" @click="showQrcode"><span>我要捐赠</span></div>
                    <div v-else style="background-color:#ccc"  class="button clearfix" ><span>我要捐赠</span></div>
                </div>
            </div>
        </div>
        <div class="colspan2 clearfix">
            <div class="colspan3">
                <!-- tab切换栏 -->
                <ul>
                    <li v-for="item in projectList" :key="item.id" :class="item.id == projectId ? 'current': '' " @click="qiehuan(item.id)">
                        <span>{{item.title}}</span>
                    </li>
                </ul>
                <!-- 项目详情 -->
                <div class="info clearfix" v-if="projectId == 1">
                    <p v-if="projectData.content" v-html="projectData.content"></p>
                </div>
                <!-- 项目进展 -->
                <div class="cooperative clearfix" v-if="projectId == 3">
                    <!-- <div>
                        <p class="date">09-30 <span>2018</span> </p>
                        <p class="title">县基金会金秋助学定向资助贫困大学生工作完成</p>
                        <p class="content">
                            2018年8月8日至9日，长沙洗心禅寺慈善基金会义工团一行10余人来到石门县，根据石门县教育基金会提供的资助
                            对象花名册，分成六个走访小组，分别前往蒙派泉、夹山、白云、三圣等十余个乡镇实地走访贫困学生家庭，
                            对资助对象进行了初选。8月底，冼心基金会根据走访的情况最终确定了20名资助对象，9月初，每人4000元资
                            助金全部打卡发放到贫困学生手中，共发放资助金80000元。
                        </p>
                    </div> -->
                    <div v-for="(item,index) in projectProgress " :key="index"  >
                        <div>
                            <p class="date">{{item.month_day}}<span>{{item.year}}</span> </p>
                            <p class="title">{{item.title}}</p>
                        </div>
                        <p class="content"  id="progressContent" v-if="item.content" v-html="item.content"></p>
                        <div  v-for="(item1,index1) in item.subsidiary_files " :key="index1" >
                           
                            <p  v-if="item1.pub_file_text.is_pic" class="enclosure">
                                <img :src="item1.pub_file_text.url" alt="">
                                <span>{{item1.name}}</span>
                            </p>
                            <p @click="fileDown(item1.id,item1.name,item1.pub_file_text.ext)"  v-else class="downLoad">
                                <span >点击下载文件：{{item1.name}}.{{item1.pub_file_text.ext}}</span>
                                <!-- <span>附件2：2018年度湖南省石门县教育基金会”圆梦行动“资助贫困大学生公示表.xlsx</span> -->
                            </p>
                        </div>
                        <!-- <p class="enclosure">
                            <img src="../../assets/images/projectInfo.png" alt="">
                            <span>项目进展附件一</span>
                        </p>
                        <p class="enclosure">
                            <img src="../../assets/images/projectInfo.png" alt="">
                            <span>项目进展附件二</span>
                        </p>
                        <p class="downLoad">
                            <span>附件1：2018年度湖南省石门县教育基金会”圆梦行动“资助贫困大学生公示表.xlsx</span>
                            <span>附件2：2018年度湖南省石门县教育基金会”圆梦行动“资助贫困大学生公示表.xlsx</span>
                        </p> -->
                    </div>
                </div>
                <!-- 捐赠记录 -->
                <div class="record" v-if="projectId == 4">
                    <div class="content">
                        <ul>
                            <li v-for="item in recordList" :key="item.id" @click="goto(item.id)">
                                <p class="p1">{{item.pub_name||'爱心人士'}}</p>
                                <p class="p2">￥{{item.money}}</p>
                                <span>{{item.created_at}}</span>
                            </li>
                            <!-- <li v-for="item in recordList" :key="item.id" @click="goto(item.id)">
                                <p class="p1">{{item.title}}</p>
                                <p class="p2">￥{{item.total}}</p>
                                <span>{{item.date}}</span>
                            </li>
                            <li v-for="item in recordList" :key="item.id" @click="goto(item.id)">
                                <p class="p1">{{item.title}}</p>
                                <p class="p2">￥{{item.total}}</p>
                                <span>{{item.date}}</span>
                            </li> -->
                        </ul>
                    </div>
                    <div class="page" v-if="recordList.length>0"  >
                        <el-pagination
                        background
                        @current-change="handleCurrentChange"
                        :current-page.sync="page"
                        layout="prev, pager, next"
                        :page-size="page_size"
                         :hide-on-single-page="true"
                        :total="total">
                        </el-pagination>
                    </div>
                </div>
                <!-- <el-dialog
                    title="请使用手机扫码"
                    :visible.sync="dialogVisible"
                    width="400px"
                >
                    <div id="qrcode"></div>
                </el-dialog> -->
                <div id="showQrcode">
                    <p>微信二维码扫一扫，进入手机捐赠</p>
                    <div id="qrcode"></div>
                </div>
                
            </div>
            <!-- 遮盖层 -->
            <div id="mask" @click="hideQrcode"></div>
            
        </div>
            
    </div>
</template>
<script>
// import func from '../../../vue-temp/vue-editor-bridge';
import QRCode from 'qrcodejs2';
    export default {
        props:{
            projectData:{
                type:Object,
                default(){
                    return {}
                }
            }
        },
        data(){
            return {
                id:null,
                second_navId:null,
                dialogVisible:false,
                page:1,
                page_size:10,
                total:0,
                projectId:1,//切换ID
                projectList:[
                    {
                        id:1,
                        title:'项目详情',
                    },
                    // {
                    //     id:2,
                    //     title:'项目报告',
                    // },
                    {
                        id:3,
                        title:'项目进展',
                    },
                    // {
                    //     id:4,
                    //     title:'合作机构',
                    // },
                    {
                        id:4,
                        title:'捐赠记录',
                    },
                ],
                recordList:[
                    // {
                    //     id:1,
                    //     project_name:'中共18大召开',
                    //     money: 8831.12,
                    //     created_at:'2019-02-12'
                    // },
                ],
                projectInfoId:null,   
                projectReport:[],//项目报告
                projectProgress:[],//项目进展  
            }
        },
        methods:{
            //切换tab
            qiehuan(id){
                this.projectId = id;
                if(id==2){
                    this.getProjectReport()
                }else if(id==3){
                    this.getProjectProgress()
                }else if(id==4){
                    this.page = 1
                    this.getRecordData()
                }
            }, 
            //捐赠记录
            //点击下一页和点击页码时执行
            handleCurrentChange(val) {
                this.getRecordData();
            },  
            getRecordData(){
                let that = this;
                this.$db
                    .get(
                    this.$url.donation.list + '?project_id='+this.projectInfoId,{page_size:this.page_size,page:this.page}  
                    )
                    .then(res => {
                    
                       this.recordList = res.data.data
                       this.total = res.data.total
                    
                    }).catch(err => {
            console.log(err);
          });
            },  

            //项目报告
            getProjectReport(){
                this.$db
                    .get(
                    this.$url.project.report.list+'?project_id='+this.projectInfoId 
                    )
                    .then(res => {
                        
                    }).catch(err => {
            console.log(err);
          });
            },
            //项目进展
            getProjectProgress(){
                
                 this.$db
                    .get(
                    this.$url.project.progress.list+'?project_id='+this.projectInfoId+"&if_show=1" 
                    )
                    .then(res => {
                        this.projectProgress = res.data
                    }).catch(err => {
            console.log(err);
          });
            },
             
            // // 下载文件
            download (data, name, suffix) {
                if (!data) {
                    return
                }
                let blob   = new Blob([data], { type: 'application/octet-stream' })
                let url    = window.URL.createObjectURL(blob)
                let alink  = document.createElement("a");
                alink.href = url;
                
                alink.download = name+'.'+suffix; //文件名
                alink.click();
               
            },
            fileDown(id,name,suffix){
                this.$db.downFilePost(this.$url.fileDown.url,{id:id}).then(res=>{
                    this.download(res.data,name,suffix )
                }).catch(err => {
            console.log(err);
          });
            },
            qrcode(){
                document.getElementById('qrcode').innerHTML = "";
                var qrcode = new QRCode('qrcode', {
                    text: this.$store.state.webInfo.donation_url+this.projectInfoId,
                    width: 256,
                    height: 256,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                })
            },
            // 我要捐赠 显示二维码
            showQrcode(){
                let qrcode =  document.getElementById('showQrcode');
                let mask = document.getElementById('mask');
                qrcode.style.display = 'block';
                mask.style.display = 'block';
                setTimeout(()=>{
                    this.qrcode();
                },0)
                document.documentElement.style.overflow='hidden';
            },
            // 隐藏二维码
            hideQrcode(){
                let qrcode =  document.getElementById('showQrcode');
                let mask = document.getElementById('mask');
                qrcode.style.display = 'none';
                mask.style.display = 'none';
                document.documentElement.style.overflow='visible';
            }
        },
        created(){
            this.projectInfoId = this.$route.query.projectInfoId
            this.getProjectProgress();
        },
       watch:{
           projectData:function(value){
               if(value){
                   this.projectInfoId = value.id
               }
           }
       }
       
    }
</script>
<style lang="less" scoped>
    #projectPC{
        .colspan2 .colspan3 .info  /deep/ img{
            max-width:calc( 100% - 2em ) !important;
        }
    }
    .colspan1 {
        // float: left;
        width: 950px;
        min-height: 300px;
        // margin: 0 auto;
        // width: 1200px;
        background-color: #ffffff;
        border: solid 1px #ccc;
        box-sizing: border-box;
        padding: 10px;
        overflow: hidden;
        > .left {
            float: left;
            width: 410px;
            height: 280px;
            overflow: hidden;
            display: flex;
            align-items: center;
            > img {
                width: 87%;
            }
        }
        > .right {
            float: left;
            width: calc(100% - 440px);
            > .top {
                display: inline-block;
                font-family: MicrosoftYaHei-Bold;
                font-size: 24px;
                width: 100%;
                height: 68px;
                box-sizing: border-box;
                padding-top: 15px;
                color: #404040;
                font-weight: 700;
                > i {
                    position: absolute;
                    left: 0;
                    top: 70px;
                    width: 520px;
                    border-bottom: 1px dashed #ccc;
                }
            }
            > .main {
                width: calc(100% + 30px);
                height: 56px;
                box-sizing: border-box;
                border-top: 1px dashed #ccc;
                border-bottom: 1px dashed #ccc;
                > .p1 {
                    float: left;
                    font-size: 14px;
                    > span {
                        font-size: 18px;
                        margin-left: 5px;
                    }
                }
                > .p2 {
                    float: right;
                    font-size: 14px;
                    margin-right: 56px;
                    > span {
                        color: #404040;
                        font-size: 18px;
                        margin-left: 5px;
                    }
                }
            }
            > .footer {
                > div {
                    margin-top: 20px;
                    color: #ccc;
                    font-size: 14px;
                    > span {
                        color: #333;
                    }
                }
                .button {
                    height:50px;
                    width:150px;
                    text-align: center;
                    line-height: 50px;
                    margin-top: 26px;
                    cursor:pointer;
                    border-radius: 4px;
                    font-size: 18px;
                    > span {
                        color: #fff;
                    }
                }
            }
        }
    }
    .colspan2 {
        // margin: 0 auto;
        // width: 1200px;
        > .colspan3 {
            float: right;
            // float: left;
            // margin: 0 auto;
            margin-top: 20px;
            // margin-left: 250px;
            width: 950px;
            min-height: 723px;
            background-color: #ffffff;
            border: solid 1px #ccc;
            box-sizing: border-box;
            > ul {
                list-style-type: none;
                margin: 0;
                padding: 0;
                height: 60px;
                line-height: 60px;
                background-color: #f5f5f5;
                box-sizing: border-box;
                > li {
                    width: 140px;
                    float: left;
                    text-align: center;
                    cursor: pointer;
                    box-sizing: border-box;
                }
                li.current {
                    font-size: 18px;
                    box-sizing: border-box;
                    background-color: #fff;
                }
            }
            > .info {
                padding: 0 30px;
                /deep/ span{
                    >img{
                        width: 95%;
                    }
                }
            }
            > .cooperative {
                padding: 30px;
                > div {
                    margin-bottom: 50px;
                    overflow: hidden;
                    p {
                        display: inline-block;
                        margin: 0;
                        padding: 0;
                    }
                    > div {
                        display: flex;
                        > .date {
                            // float: left;
                            width: 100px;
                            font-family: MicrosoftYaHei;
                            font-size: 30px;
                            font-weight: normal;
                            font-stretch: normal;
                            letter-spacing: 0px;
                            color: #404040;
                            > span {
                                display: inline-block;
                                font-size: 18px;
                            }
                        }
                        > .title {
                            font-family: MicrosoftYaHei;
                            font-size: 24px;
                            color: #404040;
                            line-height: 30px;
                            margin-left: 20px;
                            margin-top: 3px; 
                        }
                    }
                    
                    > .content { 
                        float: left;
                        margin-left: 120px;
                        margin-bottom: 65px;
                        font-family: MicrosoftYaHei;
                        font-size: 16px;
                        line-height: 36px;
                        color: #404040;
                    }
                    > div {
                        > .enclosure {
                            margin-left: 120px;
                            width: 690px;
                            height: 400px;
                            > img {
                                width: 100%;
                            }
                            > span {
                                display: inline-block;
                                overflow: hidden;
                                width: 100%;
                                text-align: center;
                                font-family: MicrosoftYaHei;
                                font-size: 16px;
                                line-height: 60px;
                                color: #404040;
                            }
                        }
                        > .downLoad {
                            margin-left: 120px;
                            width: 768px;
                            height: 100%;
                            padding: 10px 20px;
                            background-color: #fafafa;
                            margin-top: 10px;
                            > span {
                                display: block;
                                font-family: MicrosoftYaHei;
                                font-size: 16px;
                                color: #404040;
                                height: 40px;
                                line-height: 40px;
                                cursor: pointer;
                            }
                            > span:hover {
                                color: #d72324;
                                text-decoration: underline;
                            }
                        }
                    }
                        
                }
            }
            > .record {
                > .content {
                    > ul {
                        list-style-type: none;
                        padding: 0;
                        > li {
                            height: 50px;
                            line-height: 50px;
                            border-bottom: 1px dashed #ccc;
                            color: #404040;
                            font-size: 14px;
                            margin: 0 30px;
                            cursor: pointer;
                            overflow: hidden;
                            > p {
                                margin: 0;
                            }
                            > .p1 {
                                float: left;
                                width: 44%;
                            }
                            > .p2 {
                                float: left;
                            }
                            > span {
                                float: right;
                                color: #ccc;
                            }
                        }
                        > li:nth-last-child(1){
                            border-bottom: none;
                        }
                        > li:hover {
                            background-color: #f5f5f5;
                        }
                    }
                }
                > .page {
                    // position: absolute;
                    // left: 50%;
                    // bottom: 50px;
                    float: left;
                    overflow: hidden;
                    margin-left: 50%;
                    margin-top: 20px;
                    height: 100px;
                    line-height: 100px;
                    transform: translateX(-50%)
                }
                .page /deep/ .active {
                    background-color: #d72324;
                }
                .page /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
                    background-color: #d72324;
                    color: #fff ;
                }
                .page /deep/ .el-pagination.is-background .el-pager li:hover {
                    color: #d72324;
                }
            }
        }
    }
    #showQrcode {
        position: fixed;
        left: 50%;
        top: 20px;
        z-index: 9999;
        transform: translateX(-50%);
        display: none;
        > p {
            color: #d72324;
            text-align: center;
        }
    }
    #qrcode {
        // padding: 20px;
        display: inline-block;
    }
    #qrcode /deep/ img {
        background-color: #fff; //设置白色背景色
        padding: 12px; // 利用padding的特性，挤出白边
    }
    #mask {
        display: none;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 300%;
        background-color: rgba(0, 0, 0, 0.5);
    }
.cooperative /deep/#progressContent{
  img{
    max-width: calc(100% - 2em) !important;
  }
}    
</style>


// WEBPACK FOOTER //
// src/components/project/projectContent.vue